@if (!canSubscribeTeam) {
    <pp-alert [type]="alertType.Warning" message="Only the team owner or an admin can set up billing for this team. Ask them to add a payment method." />
}
@else if (clientSecret()) {
    <stripe-pricing-table [attr.client-reference-id]="clientReferenceId"
        [attr.customer-session-client-secret]="clientSecret()"
        [attr.pricing-table-id]="stripePricingTableId"
        [attr.publishable-key]="stripePublishableKey"
        [style.max-width]="limitWidthOnPricingTable() ? '360px' : 'none'" />
}
@else {
    <stripe-pricing-table [attr.client-reference-id]="clientReferenceId"
        [attr.customer-email]="clientEmail"
        [attr.pricing-table-id]="stripePricingTableId"
        [attr.publishable-key]="stripePublishableKey"
        [style.max-width]="limitWidthOnPricingTable() ? '360px' : 'none'" />
}
